import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}

// OA一键登录方法
export function loginOA(data) {
  return request({
    url: '/loginOa',
    method: 'post',
    data: data
  })
}

// 获取二维码地址
export function getQrCode(data) {
  return request({
    url: '/getQrCode',
    method: 'post',
    data: data,
    

  })
}

// 查询二维码是否为可登录状态，若是则登录
export function loginQrCode(data) {
  return request({
    url: '/loginQrCode',
    method: 'post',
    data: data,
   
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get',
   
  })
}

// 获取路由
export const getRouters = () => {
  return request({
    url: '/getRouters',
    method: 'get'
  })
}

// 获取所有枚举对象
export function getEnumCodes() {
    return request({
      url: '/enum/codes',
      method: 'get'
    })
  }
  


// WEBPACK FOOTER //
// ./src/api/login.js